import { Injectable } from '@angular/core';
import { State, StateContext, Action } from '@ngxs/store';
import { FilterPanelV2StateModel } from '../models/filter-panel-v2-state.model';
import { SaveFilterPanelV2, ClearFilterPanelV2 } from './filter-panel-v2.actions';
import { GenericState } from 'src/core/states/generic/generic.state';
import { UserStateSettingsService } from 'src/core/services/state/user-state-settings.service';

const name = 'FilterPanelV2State';

@State<FilterPanelV2StateModel>({
  name,
  defaults: { panels: {} },
})
@Injectable()
export class FilterPanelV2State extends GenericState<FilterPanelV2State> {
  constructor(userSettingsService: UserStateSettingsService) {
    super(userSettingsService);
    this.name = name;
    this.userSettingsService.register(this.name, this);
  }

  @Action(SaveFilterPanelV2)
  save(ctx: StateContext<FilterPanelV2StateModel>, action: SaveFilterPanelV2) {
    const state = { ...ctx.getState(), panels: { ...ctx.getState().panels } };
    state.panels[action.panelKey] = {
      values: action.values,
      activeSectionKey: action.activeSectionKey,
      hiddenSectionKeys: action.hiddenSectionKeys,
      disabledSectionKeys: action.disabledSectionKeys,
      isCollapsed: action.isCollapsed,
    };
    this.userSettingsService.setState(ctx, state, name);
  }

  @Action(ClearFilterPanelV2)
  clear(ctx: StateContext<FilterPanelV2StateModel>, action: ClearFilterPanelV2) {
    const state = { ...ctx.getState(), panels: { ...ctx.getState().panels } };
    const existing = state.panels[action.panelKey];
    state.panels[action.panelKey] = {
      values: action.defaultValues,
      activeSectionKey: null,
      hiddenSectionKeys: [],
      disabledSectionKeys: [],
      isCollapsed: existing?.isCollapsed ?? false,
    };
    this.userSettingsService.setState(ctx, state, name);
  }
}
